import { TourGuide } from './TourGuide';
import { TourGuidePointer } from './TourGuidePointer';

TourGuide.Pointer = TourGuidePointer;

export { TourGuide };
